<template>
  <div>
    <div  class="d-flex w-100 justify-content-between">
      <DebouncedSearch
        :placeholder="$t('global.search')"
        v-model="filters.search"
        @click="getData"
        size="sm"
        wrapper-class="flex-grow-1 mr-2" />

      <Pagination size="small" class="mr-2" :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
      <b-button-group>
        <b-button size="sm" :disabled="!!loading" v-if="list.actions && list.actions.create" class="mb-3" variant="primary" :to="{ name: 'LabelSetCreate', params: { project_id: activeProjectId } }">
          {{ $t('label_set.create_new') }}
        </b-button>
      </b-button-group>
    </div>
    <b-list-group>
      <b-list-group-item v-for="item in items" :key="item.id"
        :to="item.empty ? null : { name: 'LabelSetSamples', params: { project_id: item.project_id, label_set_id: item.id } }"
        :class="['flex-column align-items-start py-1 px-2 has-default-router-link min-row', { empty: !!item.empty }]">
        <b-spinner small v-if="item.empty && loading" type="grow" variant="primary"/>
        <div v-if="!item.empty" class="d-flex w-100 justify-content-between">
          <span>
            <small class="idcol mr-2">{{ item.id }}:</small>
            <span>{{ item.name }}</span>
          </span>
          <div class="flex-container options-center">
            <router-link class="default-router-link" v-if="item.actions.update" :to="{ name: 'LabelSetSamples', params: { project_id: item.project_id, label_set_id: item.id } }">
              <i class="mx-1 fa fa-eye fa-lg"/>
            </router-link>
            <router-link v-if="item.actions.update" :to="{ name: 'LabelSetUpdate', params: { project_id: item.project_id, id: item.id } }">
              <i class="mx-1 fa fa-edit fa-lg"/>
            </router-link>
            <!-- <a href="" @click.prevent="" @click="downloadLabelSet(item.project_id, item.id)"><i class="mx-1 fa fa-download fa-lg"/></a> -->
            <!-- <router-link v-if="item.actions.view" :to="{ name: 'LabelSetsCode'}">
              <i class="mx-1 fa fa-code fa-lg"/>
            </router-link> -->
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import { mapState } from 'vuex';
import Services from '@/services/index';
import DebouncedSearch from '../Shared/DebouncedSearch.vue';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      page: 1,
      filters: {
        search: '',
        per_page: 5,
      },
      loading: false,
      list: {},
    };
  },
  components: {
    Pagination,
    DebouncedSearch
  },
  computed: {
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    validItems() { return this.list.data || []; },
    items() {
      const emptyItemCount = this.filters.per_page - this.validItems.length;
      const emptyItems = [...Array(emptyItemCount)].map((_, idx) => ({ id: `empty${idx}`, empty: true }));
      return [...this.validItems, ...emptyItems] || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
    ...mapState('Auth', ['activeProjectId']),
  },
  watch: {
    page: 'getData',
    'filters.search'() { this.page = 1; },
    filters: { deep: true, handler: 'getData' },
    activeProjectId() {
      if (this.activeProjectId) {
        this.getData();
      } else {
        this.list = { data: [] };
      }
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.list = { data: [] };
      Services.labelSets.list(this.activeProjectId, this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
      }).catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          this.loading = false;
          console.log(err);
        }
      });
    },
    onPageChange(page) {
      this.page = page || this.page;
    },
  }
};
</script>

<style scoped lang="scss">
.has-default-router-link:hover .default-router-link {
  text-shadow: 0px 0px 2px $white, 0px 0px 4px $black;
}

.min-row {
  min-height: 2.22em;

  &.empty {
    background-color: $gray-200;
  }
}

.idcol {
  min-width: 30px;
  display: inline-block;
  text-align: right;
}
</style>
